import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';
const InputGroupText = (props)=>{
    const { className, ...rest } = props;
    return /*#__PURE__*/ _jsx("span", {
        ...rest,
        className: classNames('input-group-text', className)
    });
};
const InputGroupAddon = (props)=>{
    return /*#__PURE__*/ _jsx(InputGroupText, {
        children: props.children
    });
};
const InputGroupCheckbox = (props)=>{
    return /*#__PURE__*/ _jsx(InputGroupText, {
        children: /*#__PURE__*/ _jsx("input", {
            className: "form-check-input mt-0",
            type: "checkbox",
            ...props
        })
    });
};
const InputGroupRadio = (props)=>{
    return /*#__PURE__*/ _jsx(InputGroupText, {
        children: /*#__PURE__*/ _jsx("input", {
            className: "form-check-input mt-0",
            type: "radio",
            ...props
        })
    });
};
const InputGroupButton = (props)=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: props.children
    });
};
// eslint-disable-next-line react/display-name
export const InputGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { bsSize, hasValidation, className, componentClass: Component = 'div', ...rest } = props;
    return /*#__PURE__*/ _jsx(Component, {
        ref: ref,
        ...rest,
        className: classNames(className, 'input-group', bsSize && `input-group-${bsSize}`, hasValidation && 'has-validation')
    });
});
InputGroup.displayName = 'InputGroup';
InputGroup.Text = InputGroupText;
InputGroup.Radio = InputGroupRadio;
InputGroup.Checkbox = InputGroupCheckbox;
InputGroup.Addon = InputGroupAddon;
InputGroup.Button = InputGroupButton;
